export default __webpack_public_path__ + "static/media/cash.d5cad13a.svg";